import { useState, useEffect, useRef  } from "react"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { useMediaQuery } from "react-responsive"

import CaretDownIcon from "../CaretDownIcon/CaretDownIcon"
import ChargersMenu from "../HomeConfigure/ChargersMenu/ChargersMenu"

import styles from "./ModelsDropDown.module.scss"

const ModelsDropDown = () => {
  const params = useParams()
  const [model, setModel] = useState(params.MODELO)
  const [isOpen, setisOpen] = useState(false)
  const { t } = useTranslation()

  const containerRef = useRef(null)

  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ query: "(max-width:992px)" })
    return isMobile ? children : null
  }
  const PC = ({ children }) => {
    const isPc = useMediaQuery({ query: "(min-width: 993px)" })
    return isPc ? children : null
  }

  useEffect(() => {
    if (model !== params.MODELO) {
      setModel(params.MODELO)
      setisOpen(false)
    }
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setisOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [params, model])

  return (
    <>
      <PC>
        <div ref={containerRef}>
          <div className={styles.container} onClick={() => setisOpen(!isOpen)}>
            <div className={styles.dropDownText}>{t("ev chargers")}</div>
            <CaretDownIcon open={isOpen} />
          </div>
          {isOpen && (
            <div className={styles.contentContainer}>
              <div className={styles.floating}>
                <ChargersMenu from={"header"} />
              </div>
              <div className={styles.closeButton}>
                {/* <button className={styles.close} onClick={() => setisOpen(false)}>
                  {t("close")}
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fillRule="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      className={styles.svgRect}
                      width="31"
                      height="31"
                      rx="15.5"
                      fill="#DBE3E6"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M16.5606 15.5L21.0029 11.0577L19.9422 9.99707L15.5 14.4393L11.0577 9.99707L9.99705 11.0577L14.4393 15.5L9.99701 19.9422L11.0577 21.0029L15.4999 16.5606L19.9422 21.0029L21.0028 19.9422L16.5606 15.5Z"
                      fill="black"
                    />
                  </svg>
                </button> */}
              </div>
            </div>
          )}
        </div>
      </PC>
      <Mobile>
          <ChargersMenu from={"header"} />
      </Mobile>
    </>
  )
}

export default ModelsDropDown
